document.addEventListener('DOMContentLoaded', () => {

    const meses = [
        'enero',
        'febrero',
        'marzo',
        'abril',
        'mayo',
        'junio',
        'julio',
        'agosto',
        'septiembre',
        'octubre',
        'noviembre',
        'diciembre'
    ];

    function sumarDias(fecha, dias) {
        const nuevaFecha = new Date(fecha);
        nuevaFecha.setDate(nuevaFecha.getDate() + dias);
        return nuevaFecha;
    }

    function formatoFecha(fecha) {
        return `${fecha.getDate()} de ${meses[fecha.getMonth()]}`;
    }

    function formatoRango(inicio, fin) {

        // Mismo mes
        if (inicio.getMonth() === fin.getMonth() &&
            inicio.getFullYear() === fin.getFullYear()) {

            return `${inicio.getDate()} a ${fin.getDate()} ${meses[inicio.getMonth()]}`;
        }

        // Mes diferente
        return `${inicio.getDate()} ${meses[inicio.getMonth()]} a ${fin.getDate()} ${meses[fin.getMonth()]}`;

    }

    const hoy = new Date();

    // Compra → Hoy
    // Enviamos → Mañana
    // Te llega → Entre 3 y 45 días

    const fechaEnvio = sumarDias(hoy, 1);

    const fechaEntregaInicio = sumarDias(hoy, 3);

    const fechaEntregaFin = sumarDias(hoy, 5);

    const envio = document.getElementById('mmShip');
    const entrega = document.getElementById('mmDelivery');

    if (envio) {
        envio.textContent = formatoFecha(fechaEnvio);
    }

    if (entrega) {
        entrega.textContent = formatoRango(
            fechaEntregaInicio,
            fechaEntregaFin
        );
    }

});